import React, { useRef, useState } from 'react';
import InputLabel from '../inputLbl';
import ValidationText from '../validationText';
import Button from '../button';
import Typo from '../typo';

const InputField = ({
  inputRef,
  isIcon,
  parentExtraCls,
  inputValidate,
  type = 'text',
  onBlur = () => {},
  extraAttri = {},
  hiddenlabel,
  labelConfig,
  validationConfig,
  inputConfig,
  maxLength = 25,
  handleInput,
  iconClickHandler,
  placeholderLabel,
  inputText,
  ismaxlength
}) => {
  const parentDiv = useRef(null);
  const [charCount, setCharCount] = useState(0);

  function handleBlur(e) {
    onBlur(e);
  }
  return (
    <>
      <div
        ref={parentDiv}
        className={`si-input ${parentExtraCls ? parentExtraCls : ''} ${
          inputValidate ? 'si-invalid' : ''
        }`}
      >
        {isIcon ? (
          <div className='si-input__icon'>
            <Button variant={'onlyIcon'} icon={isIcon} onClick={(e) => iconClickHandler(e)} />
          </div>
        ) : (
          ''
        )}
        {hiddenlabel ?? <InputLabel {...labelConfig} />}
        <div className='si-input__field'>
          <input
            autoComplete='off'
            type={type}
            onBlur={handleBlur}
            ref={inputRef}
            value={inputText}
            onChange={(e) => handleInput(e)}
            maxLength={maxLength}
            onInput={(e) => setCharCount(e.target.value.length)}
            {...extraAttri}
            placeholder={placeholderLabel}
          />
          {ismaxlength && maxLength && (
            <div className='si-charCount'>
              <div className='si-charCount__lbl'>Max {maxLength} characters</div>
              <div className='si-charCount__count'>
                {charCount}/{maxLength}
              </div>
            </div>
          )}

          <ValidationText {...validationConfig} />
        </div>
      </div>
    </>
  );
};

export default InputField;
